import angular, { ILogService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { IApiRestCurriculums, ICurriculumRequestAlta, RestOptions } from 'src/model/candidato-api'

const CONFIG_NO_GESTION_ERROR: RestOptions = { _cfg: { nogestionaerror: true } }

export class CurriculumService {
  CLIENT: IApiRestCurriculums

  constructor(private $log: ILogService, private AccesoDatos: AccesoDatos) {
    this.CLIENT = this.AccesoDatos.Curr_CLIENT
  }

  sendCv(req: ICurriculumRequestAlta, accesoPublico = false) {
    if (accesoPublico) {
      return this.CLIENT.nuevoCV(req, CONFIG_NO_GESTION_ERROR)
    } else {
      return this.sendCvPriv(req)
    }
  }

  sendCvPriv(req: ICurriculumRequestAlta) {
    return this.CLIENT.nuevoCV_Secured(req, CONFIG_NO_GESTION_ERROR)
  }
}

angular.module('candidato').service('CurriculumService', CurriculumService)
